"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBurnErroring = exports.isBurnCompleted = exports.isReleased = exports.isBurnConfirmed = void 0;
const isBurnConfirmed = (x) => {
    return x.renVMHash !== undefined;
};
exports.isBurnConfirmed = isBurnConfirmed;
const isReleased = (x) => {
    return x.renResponse !== undefined;
};
exports.isReleased = isReleased;
const isBurnCompleted = (x) => {
    return x.completedAt !== undefined;
};
exports.isBurnCompleted = isBurnCompleted;
const isBurnErroring = (x) => {
    return x.error !== undefined;
};
exports.isBurnErroring = isBurnErroring;
//# sourceMappingURL=burn.js.map